let breadCrumbElm = document.querySelector('.breadcrumb');

if (breadCrumbElm != null) {
    let breadCrumbContainer = breadCrumbElm.closest('.grid-container-small');
    if (breadCrumbContainer != null) {
        breadCrumbContainer.classList.remove('grid-container-small');
        breadCrumbContainer.classList.add('grid-desktop-large');
    }
}

document.addEventListener("DOMContentLoaded", function() {
    catalogProductGrid.positionMarketingTiles();

    //ON RESIZE IF DIFFERENT BREAKPOINT DISPLACE TILES
    let currentTilesPerRow = catalogProductGrid.setTilesPerRowValue();
    $(window).on('resize', _.debounce(function () {
        if (currentTilesPerRow !== catalogProductGrid.setTilesPerRowValue()) {
            catalogProductGrid.positionMarketingTiles();
            currentTilesPerRow = catalogProductGrid.setTilesPerRowValue();
        }
    }, 1000));
});

const catalogProductGrid = function () {
    const plpDesktopBreakpoint = 1200;
    const plpDesktopOnekBreakpoint = 1900;
    const plpDesktopTwokBreakpoint = 2140;
    let screenWidth = window.innerWidth;

    const _setTilesPerRowValue = function () {
        screenWidth = window.innerWidth;
        if (screenWidth < plpDesktopBreakpoint) {
            return 6;
        }
        if (screenWidth >= plpDesktopBreakpoint && screenWidth < plpDesktopOnekBreakpoint) {
            return 5;
        }
        if (screenWidth >= plpDesktopOnekBreakpoint && screenWidth < plpDesktopTwokBreakpoint) {
            return 7;
        }
        if (screenWidth >= plpDesktopTwokBreakpoint) {
            return 8;
        }
    };

    const _positionMarketingTiles = function () {

        let injectedTiles = 0;
        let isMyFavouritePage = window.location.pathname === myFavouritesUrl;
        let itemsPerRow = catalogProductGrid.setTilesPerRowValue();
        const catalogContainer = document.querySelector('.plpGridList');
        const coveoTiles = document.querySelectorAll('.plpGridList .plp-tile');
        const plpGridTiles = document.querySelectorAll('.plpGridList .default-product-tile');
        const hasButterFlyTile = document.getElementsByClassName('has-butterfly-tile').length;
        const sponsoredTile = document.querySelectorAll('.sponsoredTile');
        let cartGeniusTile = document.getElementsByClassName('has-genius-tile');
        let cartGeniusNormal = false;
        const cartGeniusTileTip = !localStorage.getItem("hasUsedGenius") ? 1 : 0;
        const cartGeniusContainer = document.querySelector('#cartGeniusPlaceholder');
        const plpLoginAndAdsSpace =  isInWebview() || isMyFavouritePage ? '': document.querySelectorAll('.plp-gta-login');

        if ($('div[data-list-name="catalog"]').length > 0) {
            cartGeniusTile = [];
            cartGeniusNormal = document.getElementById('cartGeniusPlaceholder');
        }

        let row1TilesToPush = [];
        let row2TilesToPush = [];
        let row3TilesToPush = [];
        let row4TilesToPush = [];
        let row5TilesToPush = [];

        const injectObjectArrayToRow = function (row, objArray, adjustTo) {
            let tileIndex = (itemsPerRow * row) + adjustTo - injectedTiles - 1;
            if (typeof coveoTiles[tileIndex] !== 'undefined') {
                coveoTiles[tileIndex].before(...objArray);
            }  else {
                catalogContainer.append(...objArray);
            }
        }

        if (!hasButterFlyTile && screenWidth >= plpDesktopBreakpoint) {
            if (cartGeniusTile.length && cartGeniusTileTip > 0) {
                injectedTiles = injectedTiles + 3;
            } else if (cartGeniusTile.length) {
                injectedTiles = injectedTiles + 2;
            } else if (cartGeniusNormal) {
                injectedTiles = injectedTiles + 1;
            }
        }

        if (hasButterFlyTile && cartGeniusTile.length && cartGeniusContainer) {
            if (screenWidth < plpDesktopBreakpoint) {
                injectedTiles = injectedTiles + 1;
            } else {
                injectedTiles = injectedTiles + 2;
            }

            if (screenWidth >= plpDesktopBreakpoint) {
                if (sponsoredTile[0]) {
                    row1TilesToPush.push(sponsoredTile[0]);
                    row1TilesToPush.push(cartGeniusContainer);
                    injectObjectArrayToRow(1, row1TilesToPush, 0);
                    injectedTiles = injectedTiles + 1;
                } else {
                    row1TilesToPush.push(cartGeniusContainer);
                    if (hasButterFlyTile) {
                        injectObjectArrayToRow(1, row1TilesToPush, 1);
                    } else {
                        injectObjectArrayToRow(1, row1TilesToPush, 0);
                    }
                }
                if (cartGeniusTileTip > 0) {
                    injectedTiles = injectedTiles + 3;
                } else if (cartGeniusTile.length) {
                    injectedTiles = injectedTiles + 2;
                }
            }
        }

        if (hasButterFlyTile && !cartGeniusTile.length ) {
            if (screenWidth >= plpDesktopBreakpoint) {
                injectedTiles = injectedTiles + 2;
            } else {
                injectedTiles = injectedTiles + 1;
            }
            if(sponsoredTile[0]) {
                row1TilesToPush.push(sponsoredTile[0]);
                injectObjectArrayToRow(1, row1TilesToPush, 0);
                injectedTiles = injectedTiles + 1;
            }
            if (cartGeniusNormal) {
                injectedTiles = injectedTiles + 1;
            }
        }

        if (screenWidth < plpDesktopBreakpoint) {
            if (hasButterFlyTile && cartGeniusTile.length) {
                plpGridTiles[3].before(cartGeniusContainer);
            }
            if (hasButterFlyTile && (typeof cartGeniusNormal !== null && cartGeniusNormal.length)) {
                plpGridTiles[1].before(cartGeniusContainer);
            }
            if (hasButterFlyTile && plpLoginAndAdsSpace !== '') {
                plpGridTiles[5].before(plpLoginAndAdsSpace[0]);
            } else if (plpLoginAndAdsSpace !== '' && plpLoginAndAdsSpace) {
                plpGridTiles[6].before(plpLoginAndAdsSpace[0]);
            }
        }

        if (screenWidth >= plpDesktopBreakpoint) {
            if (sponsoredTile[0] && !hasButterFlyTile) {
                row1TilesToPush.push(sponsoredTile[0]);
                injectObjectArrayToRow(1, row1TilesToPush, 0);
                injectedTiles = injectedTiles + 1;
            }
            if (sponsoredTile[1]) {
                row2TilesToPush.push(sponsoredTile[1]);
                injectObjectArrayToRow(2, row2TilesToPush, 0);
                injectedTiles = injectedTiles + 1;
            }

            if (plpLoginAndAdsSpace.length) {
                injectObjectArrayToRow(2, plpLoginAndAdsSpace, 1);
            }
            if (sponsoredTile[2]) {
                row3TilesToPush.push(sponsoredTile[2]);
                injectObjectArrayToRow(3, row3TilesToPush, 0);
                injectedTiles = injectedTiles + 1;
            }
            if (sponsoredTile[3]) {
                row4TilesToPush.push(sponsoredTile[3]);
                injectObjectArrayToRow(4, row4TilesToPush, 0);
                injectedTiles = injectedTiles + 1;
            }
            if (sponsoredTile[4]) {
                row5TilesToPush.push(sponsoredTile[4]);
                injectObjectArrayToRow(5, row5TilesToPush, 0);
            }
        }
    };

    return {
        setTilesPerRowValue: _setTilesPerRowValue,
        positionMarketingTiles: _positionMarketingTiles,
    }
}();